import { getLocalApi } from "./localApi";
import { AccountCategory } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllAccountCategories() : Promise<AccountCategory[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_account_category, (dto:any) => ({
        id: dto.id,
        name: dto.name,
        active: dto.active ?? true,
        divisionId: dto.divisionId,
        createdBy: dto.createdBy ?? '',
        lastModifiedBy: dto.lastModifiedBy ?? '',
    }), 'Unable to fetch account categories')
}